<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu">
    <simplebar class="h-100">
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu list-unstyled" id="side-menu">
          <li class="menu-title">Main</li>
          <li>
            <router-link tag="a" to="/" class="side-nav-link">
              <i class="ti-home"></i>
              <span>Dashboard </span>
            </router-link>
          </li>
            <li>
                <router-link tag="a" to="/deposits" class="side-nav-link">
                    <i class="fas fa fa-money-bill"></i>
                    <span>Yatırım Talepleri </span>
                    <span v-if="depositsCount > 0" class="badge rounded-pill bg-danger float-end"> {{ depositsCount }} </span>
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/withdrawals" class="side-nav-link">
                    <i class="ti-money"></i>
                    <span>Çekim Talepleri </span>
                    <span v-if="withdrawalsCount > 0" class="badge rounded-pill bg-danger float-end"> {{ withdrawalsCount }} </span>
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/black-list/list" class="side-nav-link">
                    <i class="fas fa-ban"></i>
                    <span>Black List </span>
                </router-link>
            </li>
            <li>
            <a href="javascript: void(0);" class="has-arrow">
              <i class="ti-lock"></i>
              <span>Yöneticiler</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li>
                <router-link to="/settings/admin-groups" class="side-nav-link">
                  <i class="ti-lock"></i>  Yönetim Grupları
                </router-link>
              </li>
              <li>
                <router-link to="/settings/admins" class="side-nav-link">
                  <i class="ti-user"></i>  Yöneticiler
                </router-link>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript: void(0);" class="has-arrow">
              <i class="fas fa-tv"></i>
              <span>Siteler </span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li>
                <router-link to="/sites/list" class="side-nav-link">
                  <i class="fas fa-tv"></i>  Siteler
                </router-link>
              </li>
              <li>
                <router-link to="/sites/users" class="side-nav-link">
                  <i class="fas fa-users"></i>  Site Kullanıcıları
                </router-link>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript: void(0);" class="has-arrow">
              <i class="fas fa-university"></i>
              <span>Hesaplar </span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li>
                <router-link to="/accounts/bank-accounts" class="side-nav-link">
                  <i class="fas fa-university"></i>  Banka Hesapları
                </router-link>
              </li>
              <li>
                <router-link to="/accounts/groups" class="side-nav-link">
                  <i class="fas fa-users"></i>  Hesap Grupları
                </router-link>
              </li>
                <li>
                    <router-link to="/accounts/answers" class="side-nav-link">
                        <i class="fas fa-comments"></i> Yat. Hazır Cevaplar
                    </router-link>
                </li>
                <li>
                    <router-link to="/accounts/answers-withdrawals" class="side-nav-link">
                        <i class="fas fa-comments"></i> Çek Hazır Cevaplar
                    </router-link>
                </li>
            </ul>
          </li>

          <li>
            <router-link tag="a" to="/logout" class="side-nav-link text-danger">
              <i class="fas fa-sign-out-alt text-danger"></i>
              <span>[ Çıkış Yap ] </span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- Sidebar -->
    </simplebar>
  </div>
  <!-- Left Sidebar End -->
</template>
<script>
import simplebar from "simplebar-vue";
import MetisMenu from "metismenujs/dist/metismenujs";
import depositService from "@/services/depositService";

import { layoutMethods } from "@/store/helpers";

export default {
  data() {
    return {
      withdrawalsCount: 0,
        depositsCount: 0,
      paymentId: '',
      tc: '',
      tc_sorgu_response: null,
      name: '',
      amount: ''
    }
  },
  components: {
    simplebar
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    let menuRef = new MetisMenu("#side-menu");
    let links = document.getElementsByClassName("side-nav-link");
    let matchingMenuItem = null;
    for (let i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      let parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");
            const parent4 = parent3.parentElement;
            if (parent4) parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) parent5.classList.add("active");
          }
        } else {
          parent.classList.add("mm-active");
        }
      }
    }
  },
  methods: {
    ...layoutMethods,
    changeLayout(layout) {
      this.changeLayoutType({ layoutType: layout });
    },
    compactSidebar() {
      document.body.setAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
      document.body.removeAttribute("data-keep-enlarged", "true");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    iconSidebar() {
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedLayout() {
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-keep-enlarged", "true");
    },
    withdrawCount(){
      depositService.withdrawalsCount()
      .then((res) => {
        if(res.state)
          this.withdrawalsCount = res.count
      })
    },
    getTcSorgu(){
      this.tc = 'Arıyor..'
      depositService.tcSorgu({id: this.paymentId})
          .then((res) => {
            if(res.state){
              if(res.data.length > 0){
                this.tc = res.data[0].tc
                this.name = res.data[0].name
                this.amount = res.data[0].amount
              }else{
                this.tc = 'Kayıt bulunamadı.'
              }
            }else{
              this.tc = res.message
            }
          })
    },
      getDepositStatistics() {
          depositService.depositsStatistics({})
              .then((res) => {
                  if(res.state){
                      this.depositsCount = res.statistics.manualTotal
                  }
              })
      },

  },
  watch: {
    '$store.getters.newData': function() {
      if(this.$store.getters.newData)
      {
        let page = this.$store.getters.newData.page
          if(page === 'withdraw'){
              this.withdrawCount()
          }
          if(page === 'update-deposit'){
              this.getDepositStatistics()
              if(this.$store.getters.newData.sound === true){
                  this.$store.dispatch('getPlayOpened', true)
              }
          }
          if(page === 'withdraw'){
              if(this.$store.getters.newData.sound === true){
                  this.$store.dispatch('getPlayOpened', true)
              }
          }

      }
    }
  },
  created() {
    this.withdrawCount()
  }
};
</script>
